import { Container, Typography } from "@mui/material";
import { Marksome, References } from "react-marksome";
import useIsMobileView from "../../utils/hooks/useIsMobileView";

const ContactInfo = () => {
  const IsMobileView = useIsMobileView();
  const { title, bodyText1, bodyText2, email } = text;
  return (
    <Container
      disableGutters
      sx={{
        display: "flex",
        flexDirection: "column",
        px: IsMobileView ? "0%" : "5%",
        mt: IsMobileView ? "2%" : "0%",
      }}
    >
      <Typography paragraph variant="h5" align="left">
        <Marksome text={title} references={references} />
      </Typography>
      <Typography paragraph variant="body1" align="left">
        <Marksome text={bodyText1} references={references} />
      </Typography>
      <Typography paragraph variant="body1" align="left">
        <Marksome text={bodyText2} references={references} />
      </Typography>
      <Typography paragraph variant="body1" align="left">
        <Marksome text={email} references={references} />
      </Typography>
    </Container>
  );
};

export default ContactInfo;

const text = {
  title: "Oksana Palikova. PhD (vene keel, 2007), MA (logopeedia, 2022).",
  bodyText1:
    "Aastatel 1993-2019 Tartu Ülikooli õppejõud. Õppeained vene keele valdkonnas: leksikoloogia, " +
    "sõnamoodustus, leksikaalne semantika, foneetika, leksikograafia, fraseoloogia, tõlkeõpetus " +
    "(eesti-vene-eesti suund), ainedidaktika. Vene keele võõrkeelena õpetamine üldkeele ning " +
    "erialakeelena (juriidika, ajalugu). Teadushuvid: leksikograafia, toponüümia, Peipsäärsete " +
    "vanausuliste murdekõne (siin [mõningaid publikatsioone][1]).",
  bodyText2:
    "Aastatel 2019-2022 Tartu Ülikooli magistrant logopeedia erialal (lõpetatud 2022). Praegune töökoht " +
    "Lääne-Tallinna Keskhaigla (Sclerosis multiplex’i ja insuldiosakond).",
  email: "[oksana.palikova@keskhaigla.ee][2]",
};

const references: References = {
  1: () => (
    <a href="https://ut-ee.academia.edu/OksanaPalikova" target="_blank" rel="noreferrer">
      mõningaid publikatsioone
    </a>
  ),
  2: "mailto:oksana.palikova@keskhaigla.ee",
};
